// extracted by mini-css-extract-plugin
export default {"button":"ButtonWithoutDefaultStyling_button__1x-R-"};